import { render, staticRenderFns } from "./otocoudet.vue?vue&type=template&id=7090cec1&scoped=true&"
import script from "./otocoudet.vue?vue&type=script&lang=js&"
export * from "./otocoudet.vue?vue&type=script&lang=js&"
import style0 from "./otocoudet.vue?vue&type=style&index=0&id=7090cec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7090cec1",
  null
  
)

export default component.exports